<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader title="Update Category" />
  
      <!-- Category Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Category Details</h2>
            <form @submit.prevent="submitForm">
              <!-- Name Inputs for Each Language -->
              <div class="form-row" v-for="language in languages" :key="language.id">
                <div class="form-group col-md-12">
                  <label :for="`name_${language.id}`">Name ({{ language.fullName }})</label>
                  <input
                    type="text"
                    class="form-control"
                    :id="`name_${language.id}`"
                    :placeholder="`Enter Category Name in ${language.fullName}`"
                    v-model="form.names[language.id]"
                  >
                </div>
              </div>
  
              <!-- Printer ID Checkboxes - DYNAMIC FROM API -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label>Printers</label>
                  <div v-if="printers.length > 0">
                    <div 
                      class="form-check"
                      v-for="printer in printers"
                      :key="printer.id"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`printer_${printer.id}`"
                        :value="printer.id"
                        v-model="form.printerIds"
                      >
                      <label class="form-check-label" :for="`printer_${printer.id}`">
                        {{ getPrinterName(printer) }}
                      </label>
                    </div>
                  </div>
                  <div v-else>
                    <p class="text-muted">No printers found. Please add printers first.</p>
                  </div>
                </div>
              </div>
  
              <!-- ERP Warehouse Select -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="erpWarehouse">ERP Warehouse</label>
                  <select
                    class="form-control"
                    id="erpWarehouse"
                    v-model="form.erpWarehouse"
                  >
                    <option value="Warehouse A">Warehouse A</option>
                    <option value="Warehouse B">Warehouse B</option>
                    <option value="Warehouse C">Warehouse C</option>
                  </select>
                </div>
              </div>
  
              <!-- Parent Category Select -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="parentCategory">Parent Category</label>
                  <select
                    class="form-control"
                    id="parentCategory"
                    v-model="form.parentId"
                    ref="parentCategory"
                  >
                    <option value="">Select a category</option>
                    <option 
                      v-for="category in groupCategories" 
                      :key="category.id" 
                      :value="category.id"
                    >
                      {{ getCategoryName(category) }}
                    </option>
                  </select>
                </div>
              </div>
  
              <!-- Group Checkbox -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="group"
                      v-model="form.isGroup"
                    >
                    <label class="form-check-label" for="group">Group</label>
                  </div>
                </div>
              </div>
  
              <!-- Is Suspend Checkbox -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="isSuspend"
                      v-model="form.isSuspend"
                    >
                    <label class="form-check-label" for="isSuspend">Is Suspend</label>
                  </div>
                </div>
              </div>
  
              <!-- Is Process Checkbox -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="is_process"
                      v-model="form.is_process"
                    >
                    <label class="form-check-label" for="is_process">Is Process</label>
                  </div>
                </div>
              </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="cancelForm">Cancel</button>
                  <button type="submit" class="btn updatecat">Update Category</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    data() {
      return {
        categoryId: null,
        languages: [], 
        categories: [], 
        printers: [], // Add printers array
        imagePreview: null,
        form: {
          names: {}, 
          printerIds: [], 
          erpWarehouse: '',
          parentId: '',
          isGroup: false, 
          isSuspend: false, 
          is_process: false, 
          categoryImage: null,
          branchId: 1, 
        },
      };
    },
    created() {
      this.categoryId = this.$route.params.id;
  
      const storedLanguages = localStorage.getItem('languages');
      if (storedLanguages) {
        this.languages = JSON.parse(storedLanguages).reverse();
      }
  
      // Fetch the category data
      this.fetchCategoryData();
      
      // Fetch categories for parent dropdown
      this.fetchCategories();
      
      // Fetch printers from API
      this.fetchPrinters();
    },
    computed: {
      groupCategories() {
        return this.categories.filter(category => category.isGroup === 1);
      }
    },
    methods: {
      getCategoryName(category) {
        if (category.languages && category.languages.length > 0) {
          return category.languages[0].name;
        }
        return `Category ${category.id}`;
      },
      
      getPrinterName(printer) {
        // Get printer name based on available languages
        if (printer.languages && printer.languages.length > 0) {
          // Try to find name in current language or use first available
          const currentLang = this.languages.find(lang => lang.id === printer.languages[0]?.langId);
          if (currentLang) {
            return printer.languages[0].name;
          }
          return printer.languages[0].name;
        }
        return `Printer ${printer.id}`;
      },
      
      async fetchPrinters() {
        try {
          this.$root.isLoading = true;
          const token = localStorage.getItem('authToken');
          
          // Get appId from user data or localStorage
          let appId = localStorage.getItem('appId');
          
          
          // If no appId found, try to get from localStorage
          if (!appId) {
            appId = localStorage.getItem('currentAppId');
          }
          
          if (!appId) {
            console.warn('No appId found. Please select an app first.');
            this.$toast.error('Please select an application first');
            return;
          }
          
          // Add appId to request
          const response = await axios.get(`${this.$BASE_API_URL}/api/printers`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: 'application/json',
            },
            params: {
              appId: appId
            }
          });
          
          console.log('Printers API Response:', response.data);
          
          if (response.data.status && response.data.data) {
            this.printers = response.data.data;
            console.log('Printers loaded:', this.printers.length);
          } else {
            console.error('Failed to fetch printers:', response.data.message);
            this.$toast.error('Failed to load printers');
          }
        } catch (error) {
          console.error('Error fetching printers:', error);
          this.$toast.error('Error loading printers');
        } finally {
          this.$root.isLoading = false;
        }
      },
      
      async fetchCategoryData() {
        try {
          this.$root.isLoading = true; 
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/categories/${this.categoryId}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: 'application/json',
            },
          });
  
          if (response.ok) {
            const data = await response.json();
            const category = data.data;
  
            // Initialize names object with all languages
            const names = {};
            this.languages.forEach(language => {
              // Find if this language exists in the category data
              const langData = category.languages.find(lang => lang.langId === language.id);
              names[language.id] = langData ? langData.name : '';
            });
  
            // Map printer IDs (convert numbers to strings for v-model compatibility)
            const printerIds = category.printers.map(printer => printer.id.toString());
  
            // Update form
            this.form = {
              names: names,
              printerIds: printerIds,
              erpWarehouse: category.ERP_warehouse || '',
              parentId: category.parentId ? category.parentId.toString() : '',
              isGroup: category.isGroup === 1,
              isSuspend: category.isSuspend === 1,
              is_process: category.is_process === 1,
              categoryImage: null,
              branchId: category.branchId,
            };
  
            // Set image preview if image exists
            if (category.image) {
              this.imagePreview = category.image;
            }
          } else {
            console.error('Failed to fetch category data');
            this.$toast.error('Failed to load category data');
          }
        } catch (error) {
          console.error('Error fetching category data:', error);
          this.$toast.error('Error loading category data');
        } finally {
          this.$root.isLoading = false;
        }
      },
      
      handleImageUpload(event) {
        const file = event.target.files[0];
        
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imagePreview = e.target.result;
          };
          reader.readAsDataURL(file);
          
          this.form.categoryImage = file;
        } else {
          this.imagePreview = null;
          this.form.categoryImage = null;
        }
      },
      
      async fetchCategories() {
        const token = localStorage.getItem('authToken');
        try {
          this.$root.isLoading = true; 
          const response = await axios.get(`${this.$BASE_API_URL}/api/categories`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('API Response:', response.data); 
          if (response.data.status && response.data.data) {
            this.categories = response.data.data;
            console.log('Categories set:', this.categories.length); 
          }
        } catch (error) {
          console.error('Error fetching categories:', error);
          this.$toast.error('Error loading categories');
        } finally {
          this.$root.isLoading = false;
        }
      },
      
      async submitForm() {
        try {
          this.$root.isLoading = true; 
          const formData = new FormData();
  
          formData.append('isSuspend', this.form.isSuspend ?'1' : '0');
          formData.append('isGroup', this.form.isGroup ? '1' : '0');
  
          formData.append('ERP_warehouse', this.form.erpWarehouse);
          formData.append('branchId', this.form.branchId.toString());
          formData.append('parentId', this.form.parentId.toString());
          formData.append('is_process', this.form.is_process ? "1" : "0");
  
          this.form.printerIds.forEach((printerId) => {
            formData.append('printerIds[]', printerId.toString());
          });
  
          this.languages.forEach((language, index) => {
            formData.append(`names[${index}][langId]`, language.id.toString());
            formData.append(`names[${index}][name]`, this.form.names[language.id] || '');
          });
  
          if (this.form.categoryImage) {
            formData.append('image', this.form.categoryImage);
          }
  
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/categories/update/${this.categoryId}`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: 'application/json',
            },
            body: formData,
          });
  
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update category");
          }
  
          this.$toast.success('Category updated successfully!');
          this.$router.push({ name: 'CategoriesComponent' });
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error(error.message || 'An error occurred.');
        } finally {
          this.$root.isLoading = false;
        }
      },
      
      cancelForm() {
        this.$router.push({ name: 'CategoriesComponent' });
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your custom styles here */
  .class-1 {
    font-family: 'Poppins', sans-serif;
  }
  
  .logo_icon {
    max-width: 100px;
  }
  
  .updatecat {
    background-color: #4caf50;
    color: #fff;
  }
  
  .form-check {
    margin-bottom: 8px;
  }
  
  .form-check-label {
    margin-left: 5px;
  }
  </style>